import { EquipmentFunction } from './equipment-function';

export class EquipmentFunctionModelSearchResult {
  foundModel: boolean = false;
  modelName: string;
  functions: EquipmentFunction[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.foundModel = data.foundModel;
    this.modelName = data.modelName ? data.modelName : 'None';

    this.functions = [];
    if (data.functions) {
      data.functions.forEach((func: EquipmentFunction) => {
        const newFunction = new EquipmentFunction();
        newFunction.loadFromJson(func);
        this.functions.push(newFunction);
      });
    }
  }
}

export class RunnableModelSearchResult {
  foundModel: boolean = false;
  modelId: string;
  modelName: string;
  functions: EquipmentFunction[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.foundModel = data.foundModel;
    this.modelId = data.modelId;
    this.modelName = data.modelName ? data.modelName : 'None';

    this.functions = [];
    if (data.functions) {
      data.functions.forEach(func => {
        const newFunction = new EquipmentFunction();
        newFunction.loadFromJson(func);
        this.functions.push(newFunction);
      });
    }
  }
}
